$(() => {
	let lastScrollTop = 0

    // Make nav fixed, show on scroll up, hide on scroll down
	$(window).on('scroll', event => {
		let scrollTop = $(event.target).scrollTop()

        // Fix the navigation
		if (scrollTop > 5) {
			$('.navigation .fixed').addClass('floating')
		}

        // Unfix the navigation
		else {
			$('.navigation .fixed').removeClass('floating')
		}

		// If scrolling down, hide the navigation
		if (scrollTop > lastScrollTop) {
            // Hide if we don't have the mobile nav menu open
            if (!$('.navigation .mobile-nav').hasClass('active')) {
                $('.navigation .fixed').removeClass('active')
            }
		}

		// If scrolling up, show the navigation
		else {
			$('.navigation .fixed').addClass('active')
		}

		lastScrollTop = scrollTop
	})

    // Trigger scroll events
	$(window).trigger('scroll')

    // Open mobile nav menu
	$('.mobile-nav .menu-button').on('click', event => {
		const nav = $(event.target).closest('.mobile-nav')
		const mobileMenu = $('.mobile-menu-container')
		const mobileNav = mobileMenu.find('.nav')

		nav.toggleClass('active')

        if (nav.hasClass('active')) {
            mobileMenu.slideDown(100, () => {
                mobileNav.addClass('active')
            })
        }

        else {
            mobileMenu.slideUp(100, function() {
                mobileNav.removeClass('active')
            })
        }
	})

	// Hide mobile sub-menus
	const subMenu = $('.mobile-nav .main-nav .menu .sub-menu')
	subMenu.hide()

	// Prevent parent menu item link 
	const menuLink = $('.mobile-nav .main-nav .menu > ul > li.has-submenu > .text-mobile-main-nav > a')
	menuLink.on('click', event => {
    	event.preventDefault()
	})

	// Toggle mobile sub-menus
	$('.mobile-menu-container > .wrapper > .nav > .main-nav > .menu > ul > li.has-submenu').on('click', event => {
		const caret = $('.has-submenu .caret')
		$(event.target).find('.sub-menu').slideToggle()

    	// Close
		if ($(event.target).hasClass('show')) {
			$(event.target).removeClass('show')
			caret.removeClass('up')
		}

		// Open
		else {
			$(event.target).addClass('show')
			caret.addClass('up')
		}
	})

	// Prevent sub-menu toggle on submenu li's
	$('.no-toggle > .text-mobile-main-nav > a').on('click', event => {
		event.stopPropagation()
	})

	// Show search form when search icon is clicked
	$('.search-form .search-button').on('click', event => {
        const container = $(event.target).closest('.search:not(.icon)')
        const input = container.find('.search-field')

        if (!container.hasClass('active')) {
            container.addClass('active')
            input[0].focus()
        }
	})

    // Hide search form when input field loses focus
    $('.search-form .search-field').on('focusout', event => {
        const container = $(event.target).closest('.search:not(.icon)')

        container.removeClass('active')
    })
})

$(document).ready(function () {
    function updateMargin() {
        if ($(".gt_float_switcher .gt-open").length) {
            $("#gt_float_wrapper").css("margin-top", "16rem"); // Adjust margin as needed
        } else {
            $("#gt_float_wrapper").css("margin-top", "0px");
        }
    }

    // Run on page load
    updateMargin();

    // Observe changes in the DOM to detect if `.gt-open` is added/removed
    const observer = new MutationObserver(updateMargin);
    observer.observe(document.body, { subtree: true, childList: true, attributes: true });

    // Also check on window resize or other possible triggers
    $(window).on("resize", updateMargin);
});

